import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CommentControl from './CommentControl';

function CommentFeedControl({
    user,
    comments,
    active,
    headless,
    onReplyToComment,
    onEditComment,
    onEditCommentReply,
    onDeleteComment,
    onDeleteCommentReply,
    onDeleteCommentImage,
    history
}) {

    useEffect(() => {

    }, []);

    var lastAuthorId = "";

    function groupMessages(comment, idx, comments) {

        var above = comments[idx - 1];
        var below = comments[idx + 1];

        if (!above) {
            if (below && comment.authorId.toUpperCase() == below.authorId.toUpperCase() && comment.replies.length == 0) {
                return "set-first";
            }
        }

        if (above && above.authorId.toUpperCase() != comment.authorId.toUpperCase()) {
            if (below && below.authorId.toUpperCase() == comment.authorId.toUpperCase() && comment.replies.length == 0) {
                return "set-first";
            }
        }

        if (above && above.authorId.toUpperCase() == comment.authorId.toUpperCase() && above.replies.length > 0) {
            if (below && below.authorId.toUpperCase() == comment.authorId.toUpperCase() && comment.replies.length == 0) {
                return "set-first";
            }
        }

        if (above && above.authorId.toUpperCase() == comment.authorId.toUpperCase() && above.replies.length == 0) {
            if (below && below.authorId.toUpperCase() == comment.authorId.toUpperCase() && comment.replies.length == 0) {
                return "set";
            }
        }

        if (above && above.authorId.toUpperCase() == comment.authorId.toUpperCase() && above.replies.length == 0 && comment.replies.length > 0) {
            return "set-last";
        }

        if (above && above.authorId.toUpperCase() == comment.authorId.toUpperCase() && above.replies.length == 0) {
            if (!below || below && below.authorId.toUpperCase() != comment.authorId.toUpperCase()) {
                return "set-last";
            }
        }

        return "";
    }

    return (
       <React.Fragment>
            <div className="comments-container">
                <div className="comment-feed">
                    {comments && comments.length === 0 &&
                        <div className="no-comments-message">
                            <span className="far fa-comment icon"></span>
                            <div>Leave a comment below to start the discussion!</div>
                        </div>
                    }
                    {comments && comments.map((comment, commentIdx) => {
                        return (
                            <React.Fragment key={comment.id}>
                                <CommentControl comment={comment} onReplyToComment={onReplyToComment} onEditComment={onEditComment} onDeleteComment={onDeleteComment} onDeleteCommentImage={onDeleteCommentImage} mode="comment" active={active} headless={headless} cssClass={groupMessages(comment, commentIdx, comments)} />
                                {
                                    comment.replies.map((reply, idx) => {
                                        return (
                                            <CommentControl key={reply.id} comment={reply} onReplyToComment={onReplyToComment} onEditCommentReply={onEditCommentReply} onDeleteCommentReply={onDeleteCommentReply} onDeleteCommentImage={onDeleteCommentImage} mode="reply" active={active} headless={headless} cssClass={groupMessages(reply, idx, comment.replies)} />
                                        );
                                    })
                                }
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
        </React.Fragment>
        

    );

}

CommentFeedControl.propTypes =
{
    user: PropTypes.object.isRequired,
    active: PropTypes.bool,
    headless: PropTypes.bool,
    comments: PropTypes.array,
    onReplyToComment: PropTypes.func.isRequired,
    onEditComment: PropTypes.func.isRequired,
    onEditCommentReply: PropTypes.func.isRequired,
    onDeleteComment: PropTypes.func.isRequired,
    onDeleteCommentReply: PropTypes.func.isRequired,
    onDeleteCommentImage: PropTypes.func.isRequired,
    errorMessage: PropTypes.string
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentFeedControl); 


/*
 *         if (idx == 0) {
            lastAuthorId = "";
        }
        var groupValue = ""


if (comment.authorId.toUpperCase() == lastAuthorId.toUpperCase()) {
            if (comments[idx + 1] && comments[idx + 1].authorId.toUpperCase() == lastAuthorId.toUpperCase() && comment.replies.length == 0) {
                groupValue = "set";
            }
            else if (comments[idx - 1] && comments[idx - 1].replies.length == 0) {
                groupValue = "set-last";
            }

        } else {
            if (comments[idx + 1] && comment.authorId.toUpperCase() == comments[idx + 1].authorId.toUpperCase() && comment.replies.length == 0) {
                groupValue = "set-first";
            }
        }
        lastAuthorId = comment.authorId;
        return groupValue;



---

if (comment.authorId.toUpperCase() == lastAuthorId.toUpperCase()) {
            if (comments[idx + 1] && comments[idx + 1].authorId.toUpperCase() == lastAuthorId.toUpperCase() && comment.replies.length == 0) {
                groupValue = "set";
            }
            else if (comments[idx - 1] && comments[idx - 1].replies.length == 0) {
                groupValue = "set-last";
            }

        } else {
            if (comments[idx + 1] && comment.authorId.toUpperCase() == comments[idx + 1].authorId.toUpperCase() && comment.replies.length == 0) {
                groupValue = "set-first";
            }
        }
        lastAuthorId = comment.authorId;
        return groupValue;
   */


// WEBPACK FOOTER //
// ./src/components/postComments/CommentFeedControl.js